export default class TaskNoteEvents {
    public static readonly saved = "TaskNote:Saved";
}
